export const CAM = 'cam';
export const DESKTOP = 'desktop';
export const TAB = 'tab';
export const SCREEN_CAM = 'screen_cam';
export const SCREEN = 'screen';
